import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0F1F]">
        <div className="font-mono text-xs text-neutral-500 tracking-widest uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // An unverified signup holds a perfectly valid token, so without this the
  // verification step is cosmetic — anyone could type /dashboard and carry on.
  // The verify screen itself is deliberately NOT wrapped in ProtectedRoute,
  // which would make this an infinite redirect.
  if (user.email_verified === false) return <Navigate to="/verify-email" replace />;
  return children;
}
